import React from 'react'
import Slider from 'react-nouislider'
import R from 'ramda'
import debounce from 'lodash.debounce'

const DoubleInputRange = ({minValue, maxValue, validValues, onChange, onUpdate}) => {
  const nbStep = R.length(validValues)
  const internalMinValue = R.indexOf(minValue, validValues) || 0
  const internalMaxValue = R.contains(maxValue, validValues) ? R.indexOf(maxValue, validValues) : nbStep - 1
  const normalize = (values) => {
    const max = validValues[parseInt(values[1], 10)]
    const maxOrUnlimited = max == R.last(validValues) ? -1 : max
    return {
      min: validValues[parseInt(values[0], 10)],
      max: maxOrUnlimited,
    }
  }
  const debouncedOnChange = debounce((values) => {
    const normalisedValues = normalize(values)    
    onChange(normalisedValues)
  }, 300)

  const normalizeOnUpdate = (values) => {
    const normalizedValues = normalize(values) 
    onUpdate(normalizedValues)
  }

  return <Slider
    connect={true}
    start={[internalMinValue, internalMaxValue]}
    range={{min:0, max: nbStep-1}}
    animate={false}
    animationDuration={0}
    onChange={debouncedOnChange}
    onSlide={normalizeOnUpdate}
    />
}

DoubleInputRange.propTypes = {
  minValue: React.PropTypes.number.isRequired,
  maxValue: React.PropTypes.number.isRequired,
  validValues: React.PropTypes.array.isRequired,
  onChange: React.PropTypes.func.isRequired,
  onUpdate: React.PropTypes.func.isRequired,
}

export default DoubleInputRange



/** WEBPACK FOOTER **
 ** ./app/components/DoubleInputRange.jsx
 **/